<hs-no-focused-aggregate [content]="rawTradeSummary"> </hs-no-focused-aggregate>

<ng-template #rawTradeSummary>
  <raw-trade-summary
    [source]="source"
    [accountId]="accountId"
    [reconDate]="reconDate"
    [panelKey]="panelKey"
    [savedViewService]="savedViewService"
  ></raw-trade-summary>
</ng-template>
